import script from "./DefRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefRadio.vue?vue&type=script&setup=true&lang=ts"

import "./DefRadio.vue?vue&type=style&index=0&id=aac2c0da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac2c0da"]])

export default __exports__